module.exports = __webpack_public_path__ + "static/media/ccast.b5de560a.png";